export default "/images/vendor/flag-icon-css/flags/4x3/mf.svg?67ef6063455e2ea7d8b407aafa16e18c";